import { render, staticRenderFns } from "./IconCubeTransparentOutline.vue?vue&type=template&id=4f2bfc5e"
import script from "./IconCubeTransparentOutline.vue?vue&type=script&lang=js"
export * from "./IconCubeTransparentOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports